module.exports = __webpack_public_path__ + "static/media/enabledTodayIcon.d021b071.svg";